'use client';

import React, { useState } from 'react';
import useMediaQuery from '@/hooks/useMediaQuery';
import { desktop } from '@/constants/screensizes';
import EditIcon from './EditIcon';
import Spinner from '@/components/organisms/spinner';


const DeliveryAddressDetails = ({ address, country, suburb, state, postCode, name, phone, city }: any) => {
    const [isDesktop] = useMediaQuery(desktop);
    const headerFontCss = isDesktop ? 'text-28' : 'text-20';
    const editIconCss = isDesktop ? 'right-[1.5rem]' : 'right-2';
    const fontCss = isDesktop ? 'text-20 font-medium' : 'text-[15.5px] font-medium';
    const textStyles = isDesktop ? { marginRight: 'min(25%, 64px)' } : { marginRight: 'min(25%, 64px)' };
    const [isNavigating, setIsNavigating] = useState(false);
     return (
    <>
      {isNavigating && <Spinner />}

      {isNavigating && (
        <div className="overlay fixed left-0 top-0 z-50 h-full w-full bg-gray-800 opacity-75"></div>
      )} 
      <div className='bg-[#FFFFFF] p-4 mt-4 relative deliveryaddressdetails' id="delivery-address">
        <h3 className={`${headerFontCss} font-semibold`}>1. Customer Information</h3>
        <div className='md:border min-h-[80px] !border-[#D7D7D7] rounded-md mt-0 md:mt-6 p-2 w-auto flex justify-between gap-3 relative'>
            <div style={textStyles} className={`text-[#000000] flex flex-col gap-2 ${fontCss} m-2`}>  {name && <p>{name}</p>}
                {address && <p className={`text-[#000000] ${fontCss}`}>{address}</p>}

                {city && <p className={`text-[#000000] ${fontCss}`}>{city}</p>}
                {state && <p className={`text-[#000000] ${fontCss}`}>{state}</p>}
                {/* <p className={`text-[#000000] ${fontCss}`}>{`${suburb ? suburb : ""} ${postCode}`}</p> */}
                <p className={`text-[#000000] ${fontCss}`}> {postCode}</p>

                {country && <p className={`text-[#000000] ${fontCss}`}>{country === "AU" ? "Australia" : "New Zealand"}</p>}
            {phone && <p className={`text-[#000000] ${fontCss}`}>{phone}</p>}
          </div>

          <EditIcon
            location={'/checkout/#delivery-address'}
            className={`m-2 absolute ${editIconCss}`}
            disabled={false}
            onClick={() => setIsNavigating(true)}
          />
        </div>
        {isDesktop && <div className='mt-10'>
            <hr className="border-t-2 border-[#EFF0F2]" />
        </div>}
      </div>
     </>
  );
};

export default DeliveryAddressDetails;